import { useQueryClient } from "@tanstack/react-query";

import { ReviewerRequestInput, useRequestReportReviewMutation } from "@api/graphql/types-and-hooks";
import { invalidateReportReviewers, settleReviewMutation } from "@components/QaReview/hooks/reviewMutations";
import { INCLUDE_INTERNAL_REVIEWERS } from "@components/ReportReview/reviewers";
import { notifyError } from "@components/notifications/notifications";
import { useReportOptional } from "@providers/ReportProvider";

export const useReviewRequest = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const reportId = useReportOptional()?.report?.id;

  const mutation = useRequestReportReviewMutation({
    onError: () => notifyError("Error requesting review. Please try again."),
    onSuccess: async (data) => {
      const toasts = { failure: "Failed to request review", success: "Review requested" };
      if (!settleReviewMutation(data?.requestReportReview, toasts)) return;
      await invalidateReportReviewers(queryClient);
      onSuccess?.();
    },
  });

  return {
    isPending: mutation.isPending,
    request: (reviewers: ReviewerRequestInput[]) => {
      if (reportId) mutation.mutate({ reportId, includeInternal: INCLUDE_INTERNAL_REVIEWERS, reviewers });
    },
  };
};
